import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const ProgramSearchHeaderWrapper = styled.div`
  margin: 4px 0px 16px;
  .header-left {
    ${responsive.SMALL_LAPTOP`
      flex-basis: 100%;
      max-width: 100%;  
    `}
  }
  .header-right {
    text-align: end;
    margin-top: 16px;

    ${responsive.SMALL_LAPTOP`
      flex-basis: 100%;
      max-width: 100%;  
    `}

    ${responsive.MOBILE`
      margin-top: 0;
    `}

    .header-right-wrapper {
      display: flex;
      justify-content: flex-end;

      ${responsive.MOBILE`
        flex-direction: column-reverse;
      `}

      .mui-select-navigator .mui-select {
        width: 100%;
      }
    }

    .header-right-button {
      margin-left: 16px;
      &:first-child {
        text-transform: none;
      }

      ${responsive.MOBILE`
        margin: 0px 0px 16px 0px;
      `}
    }
  }
`;
